import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
export default function BasicTimePicker({
  value,
  placeholder,
  name,
  onChange,
  disabled = false,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker']}>
        <div className="custom-timepicker">
          <TimePicker
            name={name}
            // onAccept={(e) => onChange(e, name)}
            timeSteps={{ minutes: 15 }}
            // value={value ?? null}
            value={value ? dayjs(value, 'HH:mm') : null}
            label={placeholder}
            disabled={disabled}
            sx={{
              width: '180px', // Adjust width of the input field
              '& .MuiInputBase-root': {
                height: '46px', // Adjust input field height
                fontSize: '14px', // Adjust input text size
              },
              '& .MuiInputLabel-root': {
                fontSize: '12px', // Adjust label font size
              },
              '& .MuiInputLabel-root.MuiInputLabel-shrink.Mui-focused': {
                color: '#1976d2', // label color on focus
              },
              // Label stays on top (value exists, but not focused)
              '& .MuiInputLabel-root.MuiInputLabel-shrink:not(.Mui-focused)': {
                color: '#000000', // different color after filled and blurred
              },
            }}
            onChange={(newValue) => {
              if (newValue === null) {
                onChange(null, name); // cleared
              } else if (dayjs(newValue).isValid()) {
                onChange(newValue, name); // UI or keyboard input
              }
            }}
            onAccept={(newValue) => {
              if (newValue === null) {
                onChange(null, name); // cleared via UI
              } else if (dayjs(newValue).isValid()) {
                onChange(newValue, name);
              }
            }}
            slotProps={{
              field: {
                clearable: true, // ✅ Enables clear icon
              },
              textField: {
                onBlur: (e) => {
                  if (!e.target.value) {
                    onChange(null, name); // ✅ Manual clear via keyboard
                  }
                },
              },
            }}
          />
        </div>
      </DemoContainer>
    </LocalizationProvider>
  );
}
